<template>
  <div id="wrapper-navbar" :class="['navbar-'+ $store.getters.getData.template1, {'reverse navbar-browser': $store.getters.platform === 'browser', 'side-menu-on': sideMenuBrowser, 'iframe-nav': iframe}]">

    <div class="navbar-bg"></div>

    <div class="wrapper-img">
      <router-link to="/content" style="opacity: 1;">
        <img :src="$store.getters.getData.logo" :alt="$store.getters.getData.name">
      </router-link>
    </div>

    <div class="nav-bars" @click="openNav">
      <icon name="bars" :scale="2.5" class="nav-bars" :style="{ color: bgColor1 }"></icon>
    </div>

    <div class="wrapper-nav-link" :style="{ color: bgColor1 }">
      <span class="nav-link">
        <router-link to="/live-categories">{{ 'DIRECTOS' }}</router-link>
      </span>

       <span v-on:keyup.enter="goLink('content')" class="nav-link" v-on:focus="onFocus">
        <router-link to="/content">{{ "|" }}</router-link>
      </span>
      <span v-on:keyup.enter="goLink('content')" class="nav-link" v-on:focus="onFocus">
        <router-link to="/content">{{ "Inicio" }}</router-link>
      </span>
      <span v-on:keyup.enter="goLink('content')" class="nav-link" v-on:focus="onFocus">
        <router-link to="/content">{{ "Programación" }}</router-link>
      </span>
      <span v-on:keyup.enter="goLink('content')" class="nav-link" v-on:focus="onFocus">
        <router-link to="/content">{{ "Noticias" }}</router-link>
      </span>
      <span v-on:keyup.enter="goLink('content')" class="nav-link" v-on:focus="onFocus">
        <router-link to="/content">{{ "Programas" }}</router-link>
      </span>
      <span v-on:keyup.enter="goLink('content')" class="nav-link" v-on:focus="onFocus">
        <router-link to="/content">{{ "Radio" }}</router-link>
      </span>
      <span v-on:keyup.enter="goLink('search')" class="nav-link">
        <router-link to="/search"><icon name="search" :scale="1.4"></icon></router-link>
      </span>
      <span v-on:keyup.enter="goLink('search')" class="nav-link">
        <router-link to="/search"><icon name="heart" :scale="1.4"></icon></router-link>
      </span>
      <span v-on:keyup.enter="goLink('settings')" class="nav-link">
        <router-link to="/settings"><icon name="cog" :scale="1.4"></icon></router-link>
      </span>
    </div>
  </div>
</template>

<script>
import { getColorText } from '@/utils/helper-functions'
import { sideMenuBrowser } from '@/utils/constants'

export default {
  name: 'Navbar',
  data: function () {
    return {
      sideMenuBrowser: sideMenuBrowser,
      bgColor1: getColorText(this.$store.getters.client.color1)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll, false)
  },
  methods: {
    openNav: function () {
      document.getElementById('sidenav-app').style.width = 'auto'
    },
    goLink (name) { this.$router.push({name: name}) },
    onFocus: function () {
      // scroll top (tv)
      document.querySelector('#app-content').scrollTop = 0
      document.getElementById('app').scrollIntoView()
    },
    onScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.$el.querySelector('.navbar-bg').style.opacity = (scrollTop > 0) ? 1 : 0
    }
  },
  computed: {
    iframe: function () {
      return (typeof this.$route.query.iframe) !== 'undefined' && this.$store.getters.platform === 'browser'
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.onScroll, false)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

#wrapper-navbar
  position: relative
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  align-items: center;
  -webkit-align-items: center;
  height: 75px;
  max-height: 75px;
  width: 100%
  outline: none;
  padding: 0 2rem 0 2rem

  .navbar-bg
    .navbar-bg
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: -10
    opacity: 0
    transition: opacity 0.5s
    background: linear-gradient(to bottom,rgba(0,0,0,.6) 0,rgba(0,0,0,.6) 83%,rgba(0,0,0,0.6) 100%)
    background-color: rgba(0, 0, 0, 0.3)

  .wrapper-img
    max-width: 12vw;
    min-width: 100px
    max-height: inherit;
    // padding-left: 2rem;

    a
      margin: 0
      max-height: inherit;

      img
        max-width: 100%;
        height: auto;
        max-height: inherit;

  a
    display: inline-block;
    color: inherit;
    text-decoration: none;
    margin-right: 1.2rem;
    opacity: 1.0;
    font-size: 1.2rem
    font-weight: 500 !important
    text-shadow: black 2px 2px 3px;
    // transition: transform .3s;

    border-bottom-width: thin;
    border-bottom-style: solid;
    border-bottom-color: transparent;

  // a:last-child
  //   margin-right: 2.2rem;

  a:hover
    opacity: 1;

  a.router-link-exact-active
    opacity: 1;

// #wrapper-navbar:focus a.router-link-exact-active
//   transform: scale(1.2);
//   transition: transform .3s;

.nav-link
  outline: none;

  .fa-icon
    color: #009539

.nav-link:focus a
  border-bottom-width: thin;
  border-bottom-style: solid;
  border-bottom-color: transparent;

.nav-bars
  display: none
  margin-right: 1.2rem
  cursor:pointer!important

.navbar-browser.side-menu-on .nav-bars
  display: block

.navbar-browser.side-menu-on .wrapper-nav-link
  display: none

#wrapper-navbar.navbar-browser.side-menu-on
  flex-direction: row-reverse

@media screen and (max-width: 576px)
  #wrapper-navbar.navbar-browser
    flex-direction: row-reverse

  .navbar-browser .nav-bars
    display: block

  .navbar-browser .wrapper-nav-link
    display: none

.iframe-nav
  .wrapper-img, .wrapper-nav-link
    display: none!important
</style>



// WEBPACK FOOTER //
// src/templates/canal-sur/components/nav-bar.vue